import React from 'react';

import { Image } from '../data/Image';

import './ImageSlider.scss';

type ImageSliderProps = {
  width?: string;
  height?: string;
  images: Image[];
};

type ImageSliderState = {
  permantentlySelected: number | null;
  selected: number;
};

class ImageSlider extends React.Component<ImageSliderProps, ImageSliderState> {
  state = { permantentlySelected: null as number | null, selected: 0 };

  render() {
    return (
      <div className="slider">
        <div
          className="pictures"
          style={{ minWidth: this.props.width, minHeight: this.props.height }}
        >
          {this.props.images.map((image, i) => {
            // Set a low resolution fallback as a background image for the first image.
            const style = image.fallbackSrc
              ? {
                  backgroundImage: `url('${image.fallbackSrc}')`,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                }
              : null;
            return (
              <img
                alt={image.alt}
                src={image.src}
                key={image.src}
                className={this.state.selected === i ? 'selected' : ''}
                width={image.width}
                height={image.height}
                style={style}
              />
            );
          })}
        </div>
        {this.props.images.length > 1 && (
          <div className="thumbnails">
            {this.props.images.map((image, i) => (
              // Do not remove this span, as it serves as a larger hover area. This avoids flashes
              // of the permantentlySelected image when the cursor hovers between two images.
              <span
                onClick={() => this.setState({ permantentlySelected: i, selected: i })}
                onMouseOver={() => this.setState({ selected: i })}
                onMouseOut={() => this.setState({ selected: this.state.permantentlySelected ?? 0 })}
                key={image.src}
              >
                <img
                  alt={image.alt}
                  src={image.src}
                  className={
                    this.state.permantentlySelected === i || this.state.selected === i
                      ? 'selected'
                      : ''
                  }
                />
              </span>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default ImageSlider;
